"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Star = void 0;
var react_1 = __importDefault(require("react"));
var Star = function () { return (react_1.default.createElement("svg", { viewBox: "-10 -10 70 70", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M24 5V36.1765L11.6471 42.6471L14 29L4 19.3529L17.7647 17.3529L24 5Z", fill: "currentColor" }),
    react_1.default.createElement("path", { opacity: "0.3", d: "M24 5L30.2353 17.3529L44 19.3529L34 29L36.3529 42.6471L24 36.1765V5Z", fill: "currentColor" }))); };
exports.Star = Star;
